module.exports = __webpack_public_path__ + "static/media/184-thailand.cc392763.svg";